import styled from 'styled-components';
export const Wrapper = styled.ul `
  
`;
export default {
    Wrapper,
};
